@if (mode() === 'input-rob') {
  <input-inventory-rob (back)="onBack()" (save)="onSaveROB($event)"></input-inventory-rob>
} @else if (mode() === 'input-inventory') {
  <supply-details (back)="onBack()" (save)="onSaveSupplyDetails($event)"></supply-details>
} @else if (mode() === 'last-port-movements') {
  <lync-movement-selection
    [isDialog]="true"
    [title]="'ship_interface.select_last_port' | transloco"
    (saveEvent)="onSavePort($event, 2)"
    (backEvent)="onBack()"
    [queryParams]="{ 'filter[vessel_id]': profileState.profile()?.id }"
    (itemsChange)="appendVesselMovements($event)"
    [selected]="getControlByReportTypeId(portInformationForm, 2).value">
  </lync-movement-selection>
} @else if (mode() === 'next-port-movements') {
  <lync-movement-selection
    [isDialog]="true"
    [title]="'ship_interface.select_next_port' | transloco"
    (saveEvent)="onSavePort($event, 1)"
    (backEvent)="onBack()"
    [queryParams]="{ 'filter[vessel_id]': profileState.profile()?.id }"
    (itemsChange)="appendVesselMovements($event)"
    [selected]="getControlByReportTypeId(portInformationForm, 1).value">
  </lync-movement-selection>
} @else if (mode() === 'departure-port-movements') {
  <lync-movement-selection
    [isDialog]="true"
    [title]="'ship_interface.select_departure_port' | transloco"
    (saveEvent)="onSavePort($event, 38)"
    (backEvent)="onBack()"
    [queryParams]="{ 'filter[vessel_id]': profileState.profile()?.id }"
    (itemsChange)="appendVesselMovements($event)"
    [selected]="getControlByReportTypeId(portInformationForm, 38).value">
  </lync-movement-selection>
} @else if (mode() === 'arrival-port-movements') {
  <lync-movement-selection
    [isDialog]="true"
    [title]="'ship_interface.select_arrival_port' | transloco"
    (saveEvent)="onSavePort($event, 38)"
    (backEvent)="onBack()"
    [queryParams]="{ 'filter[vessel_id]': profileState.profile()?.id }"
    (itemsChange)="appendVesselMovements($event)"
    [selected]="getControlByReportTypeId(portInformationForm, 38).value">
  </lync-movement-selection>
} @else {
  <box [size]="sizeBox">
    <app-header [title]="title" [onClose]="onClose" [hasBottomBorder]="true"></app-header>
    <app-body class="py-0">
      @if (type() === 'arrival') {
        @if (currentArrivalStep() === 1) {
          <div class="border-b border-[#CBD7DF] py-6">
            @if (
              detailPortReport().status_id !== REPORT_STATUS.SUBMITTED &&
              detailPortReport().status_id !== REPORT_STATUS.SAVED &&
              ((type() === 'arrival' && currentArrivalStep() !== 4) || (type() === 'departure' && currentDepartureStep() !== 4))
            ) {
              <div>
                <step-progress class="w-full" [steps]="type() === 'arrival' ? arrivalSteps() : departureSteps()"></step-progress>
              </div>
            }
            <subtitle-block [title]="'ship_interface.arrival_port' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <autofill
                [label]="'ship_interface.arrival_port' | transloco"
                [required]="true"
                class="w-full"
                [placeholder]="'ship_interface.select_arrival_port' | transloco"
                [readonly]="true"
                [options]="vesselMovements()"
                selectType="id"
                displayName="port_name"
                (click)="onPressArrivalPort()"
                [control]="getControlByReportTypeId(portInformationForm, 38)"></autofill>
              <selection-button
                [label]="'ship_interface.is_the_vessel_currently_ballast_or_laden' | transloco"
                class="w-full px-0 py-0"
                [buttons]="buttons()"
                (buttonsChange)="onButtonsChange($event)"
                type="single-selection">
              </selection-button>
            </div>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.arrival_timings' | transloco"> </subtitle-block>
            <row>
              <form-date-picker
                [hasPadding]="false"
                [label]="'ship_interface.time_of_arrival' | transloco"
                [required]="true"
                class="w-full"
                type="date-time"
                [control]="getControlByReportTypeId(portInformationForm, 43)">
              </form-date-picker>

              <form-date-picker
                [label]="'ship_interface.esop_end_of_sea_passage' | transloco"
                class="w-full"
                type="date-time"
                [control]="getControlByReportTypeId(portInformationForm, 40)">
              </form-date-picker>
            </row>
            <row>
              <form-date-picker
                class="w-full"
                type="date-time"
                [label]="'ship_interface.nor_tendered' | transloco"
                [control]="getControlByReportTypeId(portInformationForm, 41)">
              </form-date-picker>

              <form-date-picker
                class="w-full"
                type="date-time"
                [label]="'ship_interface.anchored' | transloco"
                [control]="getControlByReportTypeId(portInformationForm, 42)">
              </form-date-picker>
            </row>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.arrival_draft' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.draft_fwd' | transloco"
                [required]="true"
                [unit]="'ship_interface.m' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(portInformationForm, 10)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.draft_mid' | transloco"
                [required]="true"
                [unit]="'ship_interface.m' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(portInformationForm, 11)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.draft_aft' | transloco"
                [required]="true"
                [unit]="'ship_interface.m' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(portInformationForm, 12)"></textbox>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.last_port' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <autofill
                [label]="'ship_interface.last_port' | transloco"
                [required]="true"
                class="w-full"
                [placeholder]="'ship_interface.select_last_port' | transloco"
                [readonly]="true"
                [options]="vesselMovements()"
                selectType="id"
                displayName="port_name"
                (click)="onPressLastPort()"
                [control]="getControlByReportTypeId(portInformationForm, 2)"></autofill>
              <textbox
                class="w-full"
                [label]="'ship_interface.actual_distance_sailed_from_last_port' | transloco"
                [required]="true"
                [unit]="'ship_interface.nm' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(portInformationForm, 44)">
              </textbox>
            </div>
          </div>
        } @else if (currentArrivalStep() === 2) {
          <div class="border-b border-[#CBD7DF] py-6">
            @if (
              detailPortReport().status_id !== REPORT_STATUS.SUBMITTED &&
              detailPortReport().status_id !== REPORT_STATUS.SAVED &&
              ((type() === 'arrival' && currentArrivalStep() !== 4) || (type() === 'departure' && currentDepartureStep() !== 4))
            ) {
              <div>
                <step-progress class="w-full" [steps]="type() === 'arrival' ? arrivalSteps() : departureSteps()"></step-progress>
              </div>
            }
            <subtitle-block [title]="'ship_interface.fuel_fresh_water_rob' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_vlsfo' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_hfo')">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_lsmgo' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_mgo')">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.fw_fresh_water' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_freshwater')">
              </textbox>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.lube_oil_rob' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.me_cyl' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_luboil_me_cyl')">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.me_sys' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_luboil_me_sys')">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.ge_sys' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_luboil_ge_sys')">
              </textbox>
            </div>
          </div>
        } @else if (currentArrivalStep() === 3) {
          <div class="border-b border-[#CBD7DF] py-6">
            @if (
              detailPortReport().status_id !== REPORT_STATUS.SUBMITTED &&
              detailPortReport().status_id !== REPORT_STATUS.SAVED &&
              ((type() === 'arrival' && currentArrivalStep() !== 4) || (type() === 'departure' && currentDepartureStep() !== 4))
            ) {
              <div>
                <step-progress class="w-full" [steps]="type() === 'arrival' ? arrivalSteps() : departureSteps()"></step-progress>
              </div>
            }
            <container
              [customClass]="
                detailPortReport().status_id !== REPORT_STATUS.SUBMITTED && detailPortReport().status_id !== REPORT_STATUS.SAVED
                  ? 'gap-[5px] flex items-center'
                  : 'gap-[5px] flex items-center'
              ">
              <mat-icon class="-mt-1 icon-size-4" [color]="'warn'" [svgIcon]="'heroicons_solid:warning'"></mat-icon>
              <p class="font-medium leading-4 text-warn">
                {{ 'ship_interface.please_enter_the_total_consumption_at_sea_last_port_departure_rob_current_port_arrival_rob' | transloco }}
              </p>
            </container>
            <subtitle-block [title]="'ship_interface.hfo_consumption' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_me' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 20)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_ge' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 21)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_blr' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 22)"></textbox>
            </div>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.mgo_consumption' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_me' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 23)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_ge' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 24)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_blr' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 25)"></textbox>
            </div>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.lube_oil_consumption' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.me_cyl' | transloco"
                [required]="true"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 26)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.me_sys' | transloco"
                [required]="true"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 27)">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.ge_sys' | transloco"
                [required]="true"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 28)"></textbox>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.fresh_water_consumption' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.fw_generated' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 29)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.fw_consumed' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 30)"></textbox>
            </div>
          </div>
        } @else {
          <div class="py-6">
            <pdf-subtitle-block
              [title]="(!isSubmitStatus() ? 'ship_interface.review_arrival_report' : 'ship_interface.arrival_report') | transloco"
              titleClass="font-extrabold text-lg"></pdf-subtitle-block>
            <div class="py-3">
              <pdf-subtitle-block
                [title]="'ship_interface.port_information' | transloco"
                [hasEdit]="!isSubmitStatus()"
                editButtonTitle=""
                [underline]="!!isSubmitStatus()"
                (edit)="onPressSection(1)"></pdf-subtitle-block>
              <div class="flex w-full flex-row">
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.arrival_port' | transloco"></pdf-subtitle-block>
                  <pdf-body-block type="short-body" [label]="'ship_interface.port' | transloco" [value]="getDetailValueByReportTypeId(38)"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.ballast_laden' | transloco"
                    [value]="
                      getDetailValueByReportTypeId(9) === 1
                        ? ('ship_interface.laden' | transloco)
                        : getDetailValueByReportTypeId(9) === 0
                          ? ('ship_interface.ballast' | transloco)
                          : ''
                    "></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.draft_fwd_mid_aft' | transloco"
                    [value]="
                      (getDetailValueByReportTypeId(10) | round: 2) +
                      ' M' +
                      ' | ' +
                      (getDetailValueByReportTypeId(11) | round: 2) +
                      ' M' +
                      ' | ' +
                      (getDetailValueByReportTypeId(12) | round: 2) +
                      ' M'
                    "></pdf-body-block>
                </div>
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.last_port' | transloco"></pdf-subtitle-block>
                  <pdf-body-block type="short-body" [label]="'ship_interface.last_port' | transloco" [value]="getDetailValueByReportTypeId(2)"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.actual_distance_from_last_port' | transloco"
                    [value]="(getDetailValueByReportTypeId(44) | round: 2) + ' NM'"></pdf-body-block>
                </div>
              </div>
              <div class="mt-3 flex w-full flex-row">
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.arrival_timings' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.time_of_arrival' | transloco"
                    [value]="(getDetailValueByReportTypeId(43) | local: { format: 'DD MMM YYYY HH:mm' }) || '-'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.esop_end_of_sea_passage' | transloco"
                    [value]="
                      getDetailValueByReportTypeId(40) ? (getDetailValueByReportTypeId(40) | local: { format: 'DD MMM YYYY HH:mm' }) : '-'
                    "></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.nor_tendered' | transloco"
                    [value]="
                      getDetailValueByReportTypeId(41) ? (getDetailValueByReportTypeId(41) | local: { format: 'DD MMM YYYY HH:mm' }) : '-'
                    "></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.anchored' | transloco"
                    [value]="
                      getDetailValueByReportTypeId(42) ? (getDetailValueByReportTypeId(42) | local: { format: 'DD MMM YYYY HH:mm' }) : '-'
                    "></pdf-body-block>
                </div>
                <div class="w-full"></div>
              </div>
            </div>
            <div class="py-3">
              <pdf-subtitle-block
                [title]="'ship_interface.arrival_rob' | transloco"
                [hasEdit]="!isSubmitStatus()"
                editButtonTitle=""
                [underline]="!!isSubmitStatus()"
                (edit)="onPressSection(2)"></pdf-subtitle-block>
              <div class="gap-3">
                <div class="flex w-full flex-row">
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.arrival_rob' | transloco"></pdf-subtitle-block>
                    <div class="flex w-full flex-row gap-2 px-13 py-3">
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.hfo' | transloco"
                        [value]="(detailBunker()?.rob_hfo | round: 2) + ' MT'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.mgo' | transloco"
                        [value]="(detailBunker()?.rob_mgo | round: 2) + ' MT'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.me_cyl' | transloco"
                        [value]="(detailBunker()?.rob_luboil_me_cyl | round: 2) + ' MT'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.me_sys' | transloco"
                        [value]="(detailBunker()?.rob_luboil_me_sys | round: 2) + ' L'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.ge_sys' | transloco"
                        [value]="(detailBunker()?.rob_luboil_ge_sys | round: 2) + ' L'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.fw' | transloco"
                        [value]="(detailBunker()?.rob_freshwater | round: 2) + ' L'"
                        class="w-full px-0 py-0">
                      </data-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="py-3">
              <pdf-subtitle-block
                [title]="'ship_interface.consumption' | transloco"
                [hasEdit]="!isSubmitStatus()"
                editButtonTitle=""
                [underline]="!!isSubmitStatus()"
                (edit)="onPressSection(3)"></pdf-subtitle-block>
              <div class="gap-3">
                <div class="flex w-full flex-row">
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.heavy_fuel_oil_vlsfo' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(20) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generator_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(21) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.boiler_room' | transloco"
                      [value]="(getDetailValueByReportTypeId(22) | round: 2) + ' MT'"></pdf-body-block>
                  </div>
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.marine_gas_oil_lsmgo' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(23) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generator_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(24) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.boiler_room' | transloco"
                      [value]="(getDetailValueByReportTypeId(25) | round: 2) + ' MT'"></pdf-body-block>
                  </div>
                </div>
                <div class="mt-3 flex w-full flex-row">
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.lubricant_oil' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine_cyliner' | transloco"
                      [value]="(getDetailValueByReportTypeId(26) | round: 2) + ' L'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine_system' | transloco"
                      [value]="(getDetailValueByReportTypeId(27) | round: 2) + ' L'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generator_engine_system' | transloco"
                      [value]="(getDetailValueByReportTypeId(28) | round: 2) + ' L'"></pdf-body-block>
                  </div>
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.fresh_water' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generated' | transloco"
                      [value]="(getDetailValueByReportTypeId(29) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.consumption' | transloco"
                      [value]="(getDetailValueByReportTypeId(30) | round: 2) + ' MT'"></pdf-body-block>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      } @else {
        @if (currentDepartureStep() === 1) {
          <div class="border-b border-[#CBD7DF] py-6">
            @if (
              detailPortReport().status_id !== REPORT_STATUS.SUBMITTED &&
              detailPortReport().status_id !== REPORT_STATUS.SAVED &&
              ((type() === 'arrival' && currentArrivalStep() !== 4) || (type() === 'departure' && currentDepartureStep() !== 4))
            ) {
              <div>
                <step-progress class="w-full" [steps]="type() === 'arrival' ? arrivalSteps() : departureSteps()"></step-progress>
              </div>
            }
            <subtitle-block [title]="'ship_interface.departure_port' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <autofill
                [label]="'ship_interface.departure_port' | transloco"
                [required]="true"
                class="w-full"
                [placeholder]="'ship_interface.select_departure_port' | transloco"
                [readonly]="true"
                [options]="vesselMovements()"
                selectType="id"
                displayName="port_name"
                (click)="onPressDeparturePort()"
                [control]="getControlByReportTypeId(portInformationForm, 38)"></autofill>
              <selection-button
                [label]="'ship_interface.is_the_vessel_currently_ballast_or_laden' | transloco"
                class="w-full px-0 py-0"
                [buttons]="buttons()"
                (buttonsChange)="onButtonsChange($event)"
                type="single-selection">
              </selection-button>
            </div>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.departure_timings' | transloco"> </subtitle-block>
            <row>
              <form-date-picker
                [label]="'ship_interface.anchor_aweigh' | transloco"
                class="w-full"
                type="date-time"
                [control]="getControlByReportTypeId(portInformationForm, 46)">
              </form-date-picker>
              <form-date-picker
                [label]="'ship_interface.stand_by_engine' | transloco"
                class="w-full"
                type="date-time"
                [control]="getControlByReportTypeId(portInformationForm, 45)">
              </form-date-picker>
            </row>
            <row>
              <form-date-picker
                [label]="'ship_interface.run_up_engine' | transloco"
                class="w-full"
                type="date-time"
                [control]="getControlByReportTypeId(portInformationForm, 47)">
              </form-date-picker>
              <form-date-picker
                [label]="'ship_interface.time_of_departure' | transloco"
                [required]="true"
                class="w-full"
                type="date-time"
                [control]="getControlByReportTypeId(portInformationForm, 48)">
              </form-date-picker>
            </row>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.departure_draft' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.draft_fwd' | transloco"
                [required]="true"
                [unit]="'ship_interface.m' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(portInformationForm, 10)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.draft_mid' | transloco"
                [required]="true"
                [unit]="'ship_interface.m' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(portInformationForm, 11)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.draft_aft' | transloco"
                [required]="true"
                [unit]="'ship_interface.m' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(portInformationForm, 12)"></textbox>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.next_port_info' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <div class="flex w-full flex-row gap-2">
                <autofill
                  [label]="'ship_interface.next_port' | transloco"
                  [required]="true"
                  class="w-full"
                  [placeholder]="'ship_interface.select_next_port' | transloco"
                  [readonly]="true"
                  [options]="vesselMovements()"
                  selectType="id"
                  displayName="port_name"
                  (click)="onPressNextPort()"
                  [control]="getControlByReportTypeId(portInformationForm, 1)"></autofill>
                <textbox
                  class="w-full"
                  [label]="'ship_interface.estimated_distance_to_next_port' | transloco"
                  [required]="true"
                  [unit]="'ship_interface.nm' | transloco"
                  [placeholder]="'0.00'"
                  type="number"
                  [isDecimal]="true"
                  [decimal]="2"
                  [control]="getControlByReportTypeId(portInformationForm, 49)">
                </textbox>
              </div>
              <form-date-picker
                class="w-full"
                [hasCalendar]="false"
                type="date-time"
                [label]="'ship_interface.eta_next_port' | transloco"
                [required]="true"
                [control]="getControlByReportTypeId(portInformationForm, 6)">
              </form-date-picker>
            </div>
          </div>
        } @else if (currentDepartureStep() === 2) {
          <div class="border-b border-[#CBD7DF] py-6">
            @if (
              detailPortReport().status_id !== REPORT_STATUS.SUBMITTED &&
              detailPortReport().status_id !== REPORT_STATUS.SAVED &&
              ((type() === 'arrival' && currentArrivalStep() !== 4) || (type() === 'departure' && currentDepartureStep() !== 4))
            ) {
              <div>
                <step-progress class="w-full" [steps]="type() === 'arrival' ? arrivalSteps() : departureSteps()"></step-progress>
              </div>
            }
            <subtitle-block [title]="'ship_interface.fuel_fresh_water_rob' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_vlsfo' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_hfo')">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_lsmgo' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_mgo')">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.fw_fresh_water' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_freshwater')">
              </textbox>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.lube_oil_rob' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.me_cyl' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_luboil_me_cyl')">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.me_sys' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_luboil_me_sys')">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.ge_sys' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="form.get('rob_luboil_ge_sys')">
              </textbox>
            </div>
          </div>
        } @else if (currentDepartureStep() === 3) {
          <div class="border-b border-[#CBD7DF] py-6">
            @if (
              detailPortReport().status_id !== REPORT_STATUS.SUBMITTED &&
              detailPortReport().status_id !== REPORT_STATUS.SAVED &&
              ((type() === 'arrival' && currentArrivalStep() !== 4) || (type() === 'departure' && currentDepartureStep() !== 4))
            ) {
              <div>
                <step-progress class="w-full" [steps]="type() === 'arrival' ? arrivalSteps() : departureSteps()"></step-progress>
              </div>
            }
            <container
              [customClass]="
                detailPortReport().status_id !== REPORT_STATUS.SUBMITTED && detailPortReport().status_id !== REPORT_STATUS.SAVED
                  ? 'gap-[5px] flex items-center'
                  : 'gap-[5px] flex items-center'
              ">
              <mat-icon class="-mt-1 icon-size-4" [color]="'warn'" [svgIcon]="'heroicons_solid:warning'"></mat-icon>
              <p class="font-medium leading-4 text-warn">
                {{ 'ship_interface.please_enter_the_total_consumption_at_port_arrival_rob_departure_rob' | transloco }}
              </p>
            </container>
            <subtitle-block [title]="'ship_interface.hfo_consumption' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_me' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 20)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_ge' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 21)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_blr' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 22)"></textbox>
            </div>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.mgo_consumption' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_me' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 23)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_ge' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 24)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_blr' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 25)"></textbox>
            </div>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.lube_oil_consumption' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.me_cyl' | transloco"
                [required]="true"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 26)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.me_sys' | transloco"
                [required]="true"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 27)">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.ge_sys' | transloco"
                [required]="true"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 28)"></textbox>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.fresh_water_consumption' | transloco"> </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.fw_generated' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 29)"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.fw_consumed' | transloco"
                [required]="true"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 30)"></textbox>
            </div>
          </div>
        } @else {
          <div class="py-6">
            <pdf-subtitle-block
              [title]="(!isSubmitStatus() ? 'ship_interface.review_departure_report' : 'ship_interface.departure_report') | transloco"
              titleClass="font-extrabold text-lg"></pdf-subtitle-block>
            <div class="py-3">
              <pdf-subtitle-block
                [title]="'ship_interface.port_information' | transloco"
                [hasEdit]="!isSubmitStatus()"
                editButtonTitle=""
                [underline]="!!isSubmitStatus()"
                (edit)="onPressSection(1)"></pdf-subtitle-block>
              <div class="flex w-full flex-row">
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.departure_port' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.departure_port' | transloco"
                    [value]="getDetailValueByReportTypeId(38)"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.ballast_laden' | transloco"
                    [value]="
                      getDetailValueByReportTypeId(9) === 1
                        ? ('ship_interface.laden' | transloco)
                        : getDetailValueByReportTypeId(9) === 0
                          ? ('ship_interface.ballast' | transloco)
                          : ''
                    "></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.draft_fwd_mid_aft' | transloco"
                    [value]="
                      (getDetailValueByReportTypeId(10) | round: 2) +
                      ' M' +
                      ' | ' +
                      (getDetailValueByReportTypeId(11) | round: 2) +
                      ' M' +
                      ' | ' +
                      (getDetailValueByReportTypeId(12) | round: 2) +
                      ' M'
                    "></pdf-body-block>
                </div>
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.last_port' | transloco"></pdf-subtitle-block>
                  <pdf-body-block type="short-body" [label]="'ship_interface.next_port' | transloco" [value]="getDetailValueByReportTypeId(1)"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.est_distance_to_next_port' | transloco"
                    [value]="(getDetailValueByReportTypeId(49) | round: 2) + ' NM'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.next_port_eta' | transloco"
                    [value]="(getDetailValueByReportTypeId(6) | local: { format: 'DD MMM YYYY HH:mm' }) || '-'"></pdf-body-block>
                </div>
              </div>
              <div class="flex w-full flex-row">
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.departure_timings' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.anchor_aweigh' | transloco"
                    [value]="
                      getDetailValueByReportTypeId(46) ? (getDetailValueByReportTypeId(46) | local: { format: 'DD MMM YYYY HH:mm' }) : '-'
                    "></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.stand_by_engine' | transloco"
                    [value]="
                      getDetailValueByReportTypeId(45) ? (getDetailValueByReportTypeId(45) | local: { format: 'DD MMM YYYY HH:mm' }) : '-'
                    "></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.run_up_engine' | transloco"
                    [value]="
                      getDetailValueByReportTypeId(47) ? (getDetailValueByReportTypeId(47) | local: { format: 'DD MMM YYYY HH:mm' }) : '-'
                    "></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.departed' | transloco"
                    [value]="(getDetailValueByReportTypeId(48) | local: { format: 'DD MMM YYYY HH:mm' }) || '-'"></pdf-body-block>
                </div>
                <div class="w-full"></div>
              </div>
            </div>
            <div class="py-3">
              <pdf-subtitle-block
                [title]="'ship_interface.departure_rob' | transloco"
                [hasEdit]="!isSubmitStatus()"
                editButtonTitle=""
                [underline]="!!isSubmitStatus()"
                (edit)="onPressSection(2)"></pdf-subtitle-block>
              <div class="gap-3">
                <div class="flex w-full flex-row">
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.departure_rob' | transloco"></pdf-subtitle-block>
                    <div class="flex w-full flex-row gap-2 px-13 py-3">
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.hfo' | transloco"
                        [value]="(detailBunker()?.rob_hfo | round: 2) + ' MT'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.mgo' | transloco"
                        [value]="(detailBunker()?.rob_mgo | round: 2) + ' MT'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.me_cyl' | transloco"
                        [value]="(detailBunker()?.rob_luboil_me_cyl | round: 2) + ' MT'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.me_sys' | transloco"
                        [value]="(detailBunker()?.rob_luboil_me_sys | round: 2) + ' L'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.ge_sys' | transloco"
                        [value]="(detailBunker()?.rob_luboil_ge_sys | round: 2) + ' L'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.fw' | transloco"
                        [value]="(detailBunker()?.rob_freshwater | round: 2) + ' L'"
                        class="w-full px-0 py-0">
                      </data-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="py-3">
              <pdf-subtitle-block
                [title]="'ship_interface.consumption' | transloco"
                [hasEdit]="!isSubmitStatus()"
                editButtonTitle=""
                [underline]="!!isSubmitStatus()"
                (edit)="onPressSection(3)"></pdf-subtitle-block>
              <div class="gap-3">
                <div class="flex w-full flex-row">
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.heavy_fuel_oil_vlsfo' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(20) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generator_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(21) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.boiler_room' | transloco"
                      [value]="(getDetailValueByReportTypeId(22) | round: 2) + ' MT'"></pdf-body-block>
                  </div>
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.marine_gas_oil_lsmgo' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(23) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generator_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(24) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.boiler_room' | transloco"
                      [value]="(getDetailValueByReportTypeId(25) | round: 2) + ' MT'"></pdf-body-block>
                  </div>
                </div>
                <div class="mt-3 flex w-full flex-row">
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.lubricant_oil' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine_cyliner' | transloco"
                      [value]="(getDetailValueByReportTypeId(26) | round: 2) + ' L'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine_system' | transloco"
                      [value]="(getDetailValueByReportTypeId(27) | round: 2) + ' L'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generator_engine_system' | transloco"
                      [value]="(getDetailValueByReportTypeId(28) | round: 2) + ' L'"></pdf-body-block>
                  </div>
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.fresh_water' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generated' | transloco"
                      [value]="(getDetailValueByReportTypeId(29) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.consumption' | transloco"
                      [value]="(getDetailValueByReportTypeId(30) | round: 2) + ' MT'"></pdf-body-block>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      }
    </app-body>
    <app-footer
      [hasTopBorder]="true"
      [onDiscard]="onDiscard"
      [onSave]="onSave"
      [disabledSaveButton]="isDisableSaveButton()"
      [saveButtonClass]="detailPortReport()?.status_id === 3 && 'bg-[#FAFAFA] text-[#FF0000]'"
      [saveButtonTitle]="saveTitle"></app-footer>
  </box>
}
